import { AxiosResponse } from "axios";
import { BaseResponse, BaseResponseLowerCase, RecordResponse } from "./BaseResponse";

function isError(
  response: BaseResponse | BaseResponseLowerCase
): boolean {
  let status = (response as BaseResponse).Status;
  if (status !== undefined) {
    return status === "error";
  }
  status = (response as BaseResponseLowerCase).status;
  if (status !== undefined) {
    return status === "error";
  }
  return false;
}

function isSuccess(
  response: BaseResponse | BaseResponseLowerCase
): boolean {
  // return response.Status === "success";
  let status = (response as BaseResponse).Status;
  if (status !== undefined) {
    return status === "success";
  }
  status = (response as BaseResponseLowerCase).status;
  if (status !== undefined) {
    return status === "success";
  }
  return false;
}

function isSuccessWithNumStatus(response: AxiosResponse<any, any>): boolean {
  return response.status === 200;
}

function isErrorWithResponse(response: RecordResponse<any>): boolean {
  return response.Status === "error" && !!response.Record;
}

const ResponseUtils = {
  isError,
  isSuccess,
  isSuccessWithNumStatus,
  isErrorWithResponse,
};

export default ResponseUtils;
